import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './kasi-economy-new-registration-form.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
var KasiEconomyNewRegistrationForm = /** @class */ (function (_super) {
    tslib_1.__extends(KasiEconomyNewRegistrationForm, _super);
    function KasiEconomyNewRegistrationForm(element) {
        return _super.call(this, element) || this;
    }
    KasiEconomyNewRegistrationForm.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.baseUrl = this.baseUrl || window.location.origin;
        if (this.form) {
            this.displayLoader = this.form.querySelector(".form-container__loader");
            this.displayFields = this.form.querySelector(".form-container__fields");
            this.displaySuccess = this.form.querySelector(".form-container__success");
            this.displayError = this.form.querySelector('.form-container__error');
        }
        this.initFieldLengths();
        this.buttonSubmit = this.element.querySelector('.js-apply-now__button-kasi-economy');
        this.doneSubmit = this.element.querySelector(".js_done-button");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.dataSharingTeleSaleHideBtn = this.element.querySelector('.data-sharing-telesale-hide-btn');
        this.dataSharingTeleSaleShowBtn = this.element.querySelector('.data-sharing-telesale-show-btn');
        this.dataSharingTeleSaleTextArea = this.element.querySelector('.data-sharing-telesale');
        this.dataSharingSmsShowBtn = this.element.querySelector('.data-sharing-email-show-btn');
        this.dataSharingSmsHideBtn = this.element.querySelector('.data-sharing-email-hide-btn');
        this.dataSharingSmsTextArea = this.element.querySelector('.data-sharing-email');
        this.dataSharingEmailHideBtn = this.element.querySelector('.data-sharing-sms-hide-btn');
        this.dataSharingEmailShowBtn = this.element.querySelector('.data-sharing-sms-show-btn');
        this.dataSharingEmailTextArea = this.element.querySelector('.data-sharing-sms');
        this.relPartiesHideBtn = this.element.querySelector('.data-rel-parties-hide-btn');
        this.relPartiesShowBtn = this.element.querySelector('.data-rel-parties-show-btn');
        this.relPartiesContent = this.element.querySelector('.data-rel-parties-content');
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        TooltipsService.initTooltips();
        this.regionSelect = this.form.querySelector('#regionSelect');
        this.populateRegionOptions();
    };
    KasiEconomyNewRegistrationForm.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonSubmit) {
            this.buttonSubmit.addEventListener("click", function (pEvent) {
                var _button = pEvent.target;
                var _form = _button.closest("form");
                var formFields = _form.querySelectorAll("input, select");
                _this.validationService.validate(formFields);
                var valid = Array.from(_form.querySelectorAll(".form__group--error"));
                if (valid.length === 0) {
                    _this.submitForm(_form);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
        if (this.doneSubmit) {
            this.doneSubmit.addEventListener('click', function () {
                _this.closeForm();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function () {
                _this.closeForm();
            });
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.removeAttribute('hidden');
            _this.dataSharingTeleSaleShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.removeAttribute('hidden');
        });
        this.dataSharingTeleSaleHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingTeleSaleTextArea.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingTeleSaleShowBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.removeAttribute('hidden');
            _this.dataSharingSmsShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.removeAttribute('hidden');
        });
        this.dataSharingSmsHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingSmsTextArea.setAttribute('hidden', 'true');
            _this.dataSharingSmsHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingSmsShowBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.removeAttribute('hidden');
            _this.dataSharingEmailShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.removeAttribute('hidden');
        });
        this.dataSharingEmailHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingEmailTextArea.setAttribute('hidden', 'true');
            _this.dataSharingEmailHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingEmailShowBtn.removeAttribute('hidden');
        });
    };
    KasiEconomyNewRegistrationForm.prototype.initFieldLengths = function () {
        var _contactNumber = this.form.querySelector("input[name=contactNo]");
        _contactNumber.setAttribute("maxlength", "10");
    };
    KasiEconomyNewRegistrationForm.prototype.closeForm = function () {
        var productPageUrl = this.form.querySelector("input[name=productPageUrl]");
        this.form.reset();
        window.location.href = productPageUrl.value;
    };
    KasiEconomyNewRegistrationForm.prototype.populateRegionOptions = function () {
        var _this = this;
        var currentDate = new Date();
        // Clear existing options (if any)
        this.regionSelect.innerHTML = "<option value=\"\"  selected>Please select a region</option>";
        // Define each location's visibility period
        var locations = [
            {
                value: "Soweto-DisoufengPub",
                label: "Gauteng - Soweto, Disoufeng Pub",
                start: new Date("2024-11-01"),
                end: new Date("2024-11-18")
            },
            {
                value: "Khayelitsha, Rands Cape Town",
                label: "Western Cape - Khayelitsha, Rands Cape Town",
                start: new Date("2024-11-25"),
                end: new Date("2024-11-28") // Updated to 28 November 2024
            },
            {
                value: "Umlazi-MaxLifestyle",
                label: "Kwazulu Natal - Umlazi, Max Lifestyle",
                start: new Date("2024-11-18"),
                end: new Date("2024-11-25") // Updated to 25 November 2024
            }
        ];
        // Populate options based on the current date and visibility period
        locations.forEach(function (location) {
            if (currentDate >= location.start && currentDate <= location.end) {
                var option = document.createElement("option");
                option.value = location.value;
                option.textContent = location.label;
                _this.regionSelect.appendChild(option);
            }
        });
    };
    KasiEconomyNewRegistrationForm.prototype.submitForm = function (form) {
        var _this = this;
        this.showDisplayView("loader");
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var subject = form.querySelector("input[name=subject]");
        var description = form.querySelector("input[name=description]");
        var firstname = form.querySelector("input[name=first-name]");
        var lastname = form.querySelector("input[name=last-name]");
        var phoneNumber = form.querySelector("input[name=contactNo]");
        var emailAddress = form.querySelector("input[name=email-address]");
        var region = form.querySelector("select[name=region]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        var currentUrl = new URL(window.location.href);
        // Get the value of the 'source' parameter
        var source = currentUrl.searchParams.get('source');
        var currentSource = 'COZA';
        if (source) {
            currentSource = source;
        }
        var _postData = {
            'email': (email ? email.value : ""),
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'product': (description ? description.value : ""),
            'formLocation': this.formLocationService.getLocation(),
            'firstName': (firstname ? firstname.value : ""),
            'lastName': (lastname ? lastname.value : ""),
            'phoneNumber': (phoneNumber ? phoneNumber.value : ""),
            'emailAddress': (emailAddress ? emailAddress.value : ""),
            'region': (region ? region.value : ""),
            'dataPrivacyConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
            'dataSharingGroup': this.dataConsentService.getDataConsentValue(form, 'data-sharing-group'),
            'dataSharing3rdParty': this.dataConsentService.getDataConsentValue(form, 'data-sharing-3rd-party'),
            'dataSharingBoarders': this.dataConsentService.getDataConsentValue(form, 'data-sharing-boarders'),
            'dataSharingTelesale': this.dataConsentService.getDataConsentValue(form, 'data-sharing-telesale'),
            'dataSharingEmail': this.dataConsentService.getDataConsentValue(form, 'data-sharing-email'),
            'dataSharingSms': this.dataConsentService.getDataConsentValue(form, 'data-sharing-sms'),
            'source': currentSource,
        };
        var url = this.baseUrl + "/bcleadUtils/save-kasi-economy-lead";
        // config
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, _postData, _config).then(function (pResponse) {
            var _response = pResponse.data;
            if (_response.toString().includes('invalid')) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                _this.showDisplayView("error");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", pResponse.code);
                _this.showDisplayView("success");
            }
        }).catch(function (pError) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            _this.showDisplayView("error");
        });
    };
    KasiEconomyNewRegistrationForm.prototype.showDisplayView = function (pDisplay) {
        this.displayLoader.classList.add("hidden");
        this.displayFields.classList.add("hidden");
        this.displaySuccess.classList.add("hidden");
        this.displayError.classList.add("hidden");
        switch (pDisplay) {
            case "success":
                this.displaySuccess.classList.remove("hidden");
                break;
            case "error":
                this.displayError.classList.remove("hidden");
                break;
            case "loader":
                this.displayLoader.classList.remove("hidden");
                break;
            default:
                this.displayFields.classList.remove("hidden");
        }
    };
    return KasiEconomyNewRegistrationForm;
}(Base));
export { KasiEconomyNewRegistrationForm };



//////////////////
// WEBPACK FOOTER
// ./components/kasi-economy-new-registration-form/kasi-economy-new-registration-form.component.ts
// module id = 1093
// module chunks = 0